import { m } from "framer-motion";
import { useCallback, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

import { useLocales, useTranslate } from "src/locales";

import Iconify from "src/components/iconify";
import { varHover } from "src/components/animate";
import CustomPopover, { usePopover } from "src/components/custom-popover";

// ----------------------------------------------------------------------
const ISO_TO_APP: Record<string, string> = {
  sr: "srb",
  el: "gre",
  de: "ger",
  en: "en",
  fr: "fr",
  hu: "hu",
  bg: "bg",
};
export default function LanguagePopover() {
  const popover = usePopover();
  const { t, onChangeLang } = useTranslate();
  const { allLangs, currentLang, initialSource } = useLocales();

  const setLS = (k: string, v: string) => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.setItem(k, v);
      }
    } catch {
      /* ignore */
    }
  };
  // Apply detected language once if it didn't come from storage
  // Inside your component:
  useEffect(() => {
    const hasStored =
      !!localStorage.getItem("i18nextLng") ||
      /(?:^|;\s*)i18nextLng=/.test(document.cookie) ||
      /(?:^|;\s*)i18next=/.test(document.cookie);
    if (hasStored) return;
    const browserApp = pickBrowserAppLang();
    if (!browserApp) return;

    if (currentLang?.value !== browserApp) {
      onChangeLang(browserApp);
      persistLang(browserApp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLang?.value, onChangeLang]);

  const handleChangeLang = useCallback(
    (newLang: string) => {
      onChangeLang(newLang);
      setLS("i18nextLng", newLang);
      popover.onClose();
    },
    [onChangeLang, popover]
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          ...(popover.open && { bgcolor: "action.selected" }),
        }}
      >
        <Iconify
          icon={currentLang.icon}
          sx={{ borderRadius: 0.65, width: 28, mt: -0.5 }}
        />
      </IconButton>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        sx={{ width: 160 }}
      >
        {allLangs.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handleChangeLang(option.value)}
            translate="no"
          >
            <Box
              component="span"
              sx={{ display: "inline-flex", flexShrink: 0 }}
            >
              <Iconify
                icon={option.icon}
                sx={{ borderRadius: 0.65, width: 28 }}
              />
            </Box>
            <Box component="span">{option.label}</Box>
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}
function pickBrowserAppLang(): string {
  if (typeof navigator === "undefined") return "";
  const raw = (
    navigator.languages?.[0] ||
    navigator.language ||
    ""
  ).toLowerCase();
  const primary = raw.split("-")[0]; // e.g., "sr-Latn-RS" -> "sr"
  return ISO_TO_APP[primary] || primary;
}

function persistLang(val: string) {
  try {
    localStorage.setItem("i18nextLng", val);
    document.cookie = `i18nextLng=${encodeURIComponent(
      val
    )}; path=/; max-age=31536000; samesite=lax`;
  } catch {}
}
// export default function LanguagePopover() {
//   const popover = usePopover();

//   const { t, onChangeLang } = useTranslate();

//   const { allLangs, currentLang } = useLocales();

//   const handleChangeLang = useCallback(
//     (newLang: string) => {
//       onChangeLang(newLang);
//       popover.onClose();
//     },
//     [onChangeLang, popover]
//   );

//   return (
//     <>
//       <IconButton
//         component={m.button}
//         whileTap="tap"
//         whileHover="hover"
//         variants={varHover(1.05)}
//         onClick={popover.onOpen}
//         sx={{
//           width: 40,
//           height: 40,
//           ...(popover.open && {
//             bgcolor: "action.selected",
//           }),
//         }}
//       >
//         <Iconify
//           icon={currentLang.icon}
//           sx={{ borderRadius: 0.65, width: 28, mt: -0.5 }}
//         />
//       </IconButton>

//       <CustomPopover
//         open={popover.open}
//         onClose={popover.onClose}
//         sx={{ width: 160 }}
//       >
//         {allLangs.map((option) => (
//           <MenuItem
//             key={option.value}
//             selected={option.value === currentLang.value}
//             onClick={() => handleChangeLang(option.value)}
//           >
//             <Iconify
//               icon={option.icon}
//               sx={{ borderRadius: 0.65, width: 28 }}
//             />

//             {option.label}
//           </MenuItem>
//         ))}
//       </CustomPopover>
//     </>
//   );
// }
